export const RESET = 'DATABASECONNECTION_LIST_RESET'
export const SET_ITEMS = 'DATABASECONNECTION_LIST_SET_ITEMS'
export const SET_ERROR = 'DATABASECONNECTION_LIST_SET_ERROR'
export const SET_VIEW = 'DATABASECONNECTION_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'DATABASECONNECTION_LIST_TOGGLE_LOADING'
